import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { HeaderComponent } from './header/header.component';
import { ThemeToggleComponent } from './header/theme-toggle/theme-toggle.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { NotificationsComponent } from './header/notifications/notifications.component';
import { GlobalSearchComponent } from './global-search/global-search.component';
import { ShrinkMenuDirective } from './side-menu/shrink-menu.directive';
import { ToggleSubmenuDirective } from './side-menu/toggle-submenu.directive';
import { HasPermissionModule } from '../shared/directives/has-permission/has-permission.module';
import { IconsModule } from '../shared/design/icons.module';
import { TooltipModule } from '../shared/directives/tooltip/tooltip.module';

@NgModule({
  declarations: [
    ThemeToggleComponent,
    AuthComponent,
    ErrorPageComponent,
    HeaderComponent,
    SideMenuComponent,
    NotificationsComponent,
    GlobalSearchComponent,
    ShrinkMenuDirective,
    ToggleSubmenuDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    HasPermissionModule,
    IconsModule,
    TooltipModule
  ],
  exports: [
    HeaderComponent,
    SideMenuComponent,
    ErrorPageComponent
  ],
  providers: []
})
export class CoreModule {

}
